import { render, staticRenderFns } from "./Comp3t3.vue?vue&type=template&id=6d265121&scoped=true&"
import script from "./Comp3t3.vue?vue&type=script&lang=js&"
export * from "./Comp3t3.vue?vue&type=script&lang=js&"
import style0 from "./Comp3t3.vue?vue&type=style&index=0&id=6d265121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d265121",
  null
  
)

export default component.exports